import { Panel } from 'primereact/panel';
import { useTranslation } from "react-i18next";
import NadaConsta from "../../../../components/nadaConsta";
import { formatarCPF } from "../../../../utils";

export function AntecedentesCriminaisPF({
  data,
  isConsultaNova,
}: {
  data: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  const documentoNaoEncontrado = !!data?.documentoNaoEncontrado;
  const possuiAntecedentes = !!data?.possuiAntecedentesCriminais;

  const getIdentificacao = () => [
    { label: t('cpf'), value: formatarCPF(data?.cpf) },
    { label: t('nome'), value: data?.nome },
    { label: t('nomeMae'), value: data?.nomeMae },
    { label: t('dataNascimento'), value: data?.dataNascimento },
  ];

  const getCertidao = () => [
    { label: t('numeroCertidao'), value: data?.numeroCertidao },
    { label: t('status'), value: data?.status },
    { label: t('dataEmissao'), value: data?.dataEmissao },
    { label: t('dataValidade'), value: data?.dataValidade },
  ];

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                backgroundColor: possuiAntecedentes ? '#FEF2F2' : '#F0FDF4',
                borderRadius: '10px',
                padding: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <i
                className={possuiAntecedentes ? 'pi pi-exclamation-triangle' : 'pi pi-check-circle'}
                style={{ color: possuiAntecedentes ? '#DC2626' : '#16A34A', fontSize: '18px' }}
              />
            </div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('antecedentesCriminais')}
            </h3>
          </div>
          {!documentoNaoEncontrado && (
            <span
              style={{
                backgroundColor: possuiAntecedentes ? '#FEF2F2' : '#F0FDF4',
                color: possuiAntecedentes ? '#DC2626' : '#16A34A',
                border: `1px solid ${possuiAntecedentes ? '#FECACA' : '#BBF7D0'}`,
                borderRadius: '20px',
                padding: '4px 14px',
                fontSize: '0.75rem',
                fontWeight: 700,
              }}
            >
              {possuiAntecedentes ? t('possuiAntecedentesCriminais') : t('naoPossuiAntecedentesCriminais')}
            </span>
          )}
        </div>

        {documentoNaoEncontrado ? (
          <NadaConsta />
        ) : (
          <>
            {/* Identificação */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px',
                marginBottom: '20px',
              }}
            >
              {getIdentificacao().map(f => (
                <div key={f.label} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <span style={{ fontSize: '0.7rem', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase' }}>
                    {f.label}
                  </span>
                  <span style={{ fontSize: 'small', color: '#1F2937', fontWeight: 500, wordBreak: 'break-word' }}>
                    {f.value || '—'}
                  </span>
                </div>
              ))}
            </div>

            {/* Certidão */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px',
                padding: '16px',
                backgroundColor: '#F9FAFB',
                borderRadius: '10px',
                border: '1px solid #F3F4F6',
              }}
            >
              {getCertidao().map(f => (
                <div key={f.label} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <span style={{ fontSize: '0.7rem', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase' }}>
                    {f.label}
                  </span>
                  <span style={{ fontSize: 'small', color: '#1F2937', fontWeight: 500, wordBreak: 'break-word' }}>
                    {f.value || '—'}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <Panel header={t('antecedentesCriminais')}>
      {documentoNaoEncontrado ? (
        <NadaConsta />
      ) : (
        <>
          <div className="grid">
            {getIdentificacao().map(f => (
              <div key={f.label} className="col p-fluid flex flex-wrap">
                <div>
                  <label className="label-dados">{f.label}</label>
                  <div>{f.value || '—'}</div>
                </div>
              </div>
            ))}
          </div>
          <br></br>
          <div className="grid">
            {getCertidao().map(f => (
              <div key={f.label} className="col p-fluid flex flex-wrap">
                <div>
                  <label className="label-dados">{f.label}</label>
                  <div>{f.value || '—'}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </Panel>
  );
}
